import { useState } from 'react';
import { applyTheme, currentTheme, otherTheme, type Theme } from '../lib/theme';
import { Icon } from './Icon';

const LABEL: Record<Theme, string> = { dark: 'تیره', light: 'روشن' };

/**
 * One button that flips the console between the dark NOC palette and the light one (W4). The label
 * names the theme you are IN and the title names where a click goes, because an icon-only theme switch
 * is the classic control whose state nobody can read. Not persisted by design — see `lib/theme.ts`.
 */
export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(() => currentTheme());
  const next = otherTheme(theme);
  return (
    <button
      type="button"
      className="btn btn-ghost btn-sm"
      aria-label={`تم کنسول: ${LABEL[theme]} — رفتن به ${LABEL[next]}`}
      title={`تم ${LABEL[theme]} است؛ کلیک برای ${LABEL[next]} (فقط برای همین زبانه)`}
      onClick={() => {
        applyTheme(next);
        setTheme(next);
      }}
      data-testid="theme-toggle"
      data-theme-value={theme}
    >
      <Icon name="theme" size={14} />
      {LABEL[theme]}
    </button>
  );
}
